import fieldsDefinition from '../components/details/FieldInfo.json';

export function currencyFormatWithDollar(num) {
  if(num){
    return '$' + num?.toFixed(0)?.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  } else {
    return '$0';
  }
}
export function currencyFormat(stringOfNum) {
  if (stringOfNum) {
    try {
      return stringOfNum?.replaceAll(",", "")?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    } catch (e) {
      return stringOfNum;
    }
  } else {
    return '';
  }
}
export function percentFormat(num) {
  if (num) {
    try {
      if (num === 0) {
        return '0%';
      } else {
        return num?.toFixed(2)?.replaceAll(",", "")?.replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '%';
      }
    } catch (e) {
      return '0%';
    }
  } else {
    return '0%';
  }
}
export function removeDecimalWithoutDefault(valueBeforeRemoval) {
  if (valueBeforeRemoval == null) {
    return "";
  }
  const numberWithoutDecimals = valueBeforeRemoval
    .toString()
    .replace(".", "");
  return numberWithoutDecimals;
}
;

export function removeDecimal(valueBeforeRemoval) {
  let numberWithoutDecimals = "0";
  if (valueBeforeRemoval) {
    numberWithoutDecimals = valueBeforeRemoval.toString().replace('.', '');
  }
  return numberWithoutDecimals;
}
export function removeNegativeWithoutDefault(valueBeforeRemoval) {
  if (valueBeforeRemoval == null) {
    return "";
  }
  const numberWithoutNegatives = valueBeforeRemoval
    .toString()
    .replace("-", "");
  return numberWithoutNegatives;
}
;

export function removeNegative(valueBeforeRemoval) {
  let numberWithoutNegatives = "0";
  if (valueBeforeRemoval) {
    numberWithoutNegatives = valueBeforeRemoval.toString().replace('-', '');
  }
  return numberWithoutNegatives;
}
export function removeLettersWithoutDefault(valueBeforeRemoval) {
  if (valueBeforeRemoval == null) {
    return "";
  }
  const numberWithoutLetters = valueBeforeRemoval
    .toString()
    .replace(/[a-zA-Z]/g, "");
  return numberWithoutLetters;
}
;

export function removeLetters(valueBeforeRemoval) {
  let numberWithoutLetters = "0";
  if (valueBeforeRemoval) {
    numberWithoutLetters = valueBeforeRemoval.toString().replace(/[a-zA-Z]/g, '');
  }
  return numberWithoutLetters;
}

export const getNoQuotes = (val) => {
  if(val){
    const valNoQuotes = val.replace(/'/g,'');
    return valNoQuotes;
  } else {
    return '';
  }
}

export function removeLeadingZeros(valueBeforeRemoval) {
  let numberWithLeadingZeros = "0";
  if (valueBeforeRemoval) {
    numberWithLeadingZeros = valueBeforeRemoval.toString().replace(/^0/, "");
  }
  return numberWithLeadingZeros;
}

export const chop = (value, length) => {
  //Remove the new lines and carriage returns
  if (value && value.toString().length > length) {
    return value?.toString()?.replaceAll(/[\n\r]/g, '')?.trim()?.substr(0, length) + "...";
  } else {
    return value?.toString()?.replaceAll(/[\n\r]/g, '')?.trim();
  }
};


export function getCurrency(value) {
  return `$${value}`;
}

export function addCommas(amount) {
  //Returns a string
  if (amount) {
    return amount.toString().replaceAll(",", "").replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  } else {
    return '0';
  }
}

export function removeCommas(cost) {
  let newCost = 0;
  if (cost) {
    newCost = parseInt(cost.toString().replaceAll(",", ""));
  }
  return newCost;
}

export function getNameOfOption(value, field, transitionBetweenValues) {
  const currentfieldInfo = fieldsDefinition[field];
  let selectedValue = value;
  if (currentfieldInfo) {
    const domain = currentfieldInfo.domain;
    if (domain) {
      const codedValues = domain.codedValues;
      if (codedValues && codedValues.length > 0) {
        const selectedItem = codedValues.filter(item => item.code === value);
        if (selectedItem.length > 0) {
          let selectedItemName = selectedItem[0].name;
          selectedValue = selectedItemName;
        }
      }
    }
  }
  return selectedValue;
}
export const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export function commaFormatter(num) {
  return num?.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

